<template>
	<div id="slips" class="betslip">
		<!-- /// Slip -->
		<div class="betslip-content">
			<div v-if="bets.length > 0" class="rounded-card">
				<bet
					v-for="(bet, keyValue) in bets"
					:bet="bet"
					:key="bet.matchId"
					:currentTime="currentTime"
					:keyValue="keyValue + 1"
				/>
			</div>
			<load-betslip v-else class="betslip__load-code" />

			<!-- /// Recommendation -->
			<recommendation-slider
				v-if="
					!settings.seeRecommendations &&
					env.availableFeatures.recommendations &&
					bets.length > 0
				"
				:bets="bets"
			/>
		</div>

		<!-- /// Details -->
		<div class="betslip__details" v-if="bets.length > 0">
			<div class="betslip__details__container" style="flex-direction: column">
				<div class="" v-if="env.availableFeatures.accaBonus">
					<!-- /// Bingwa Boost -->
					<acca-bonus
						:possibleWin="possiblePayout"
						:bets="bets"
						v-if="
							env.availableFeatures.accaBonus &&
							!freebetAppliedStatus &&
							$store.getters.balance > 0
						"
						@mounted="
							$nextTick(() => {
								adjustBetslipHeight();
							})
						"
						@accaBonusAmt="getAccaBonusAmt"
					/>
				</div>

				<div class="betslip__details__left">
					<!-- /// Win Boost -->
					<div
						class="betslip__details__left__row"
						v-if="
							bets.length > 0 &&
							winBoost <= 0 &&
							winBoostFactor > 0 &&
							amount > 0
						"
					>
						<p
							style="
								margin: 0px auto;
								text-align: center;
								display: flex;
								width: 96%;
								border: 1px solid rgb(236, 199, 65);
								background-color: rgb(245, 229, 180);
								color: rgb(169, 135, 11);
								padding: 5px 10px;
								border-radius: 1px;
								align-items: center;
								justify-content: center;
							"
						>
							<svg
								version="1.1"
								id="Capa_1"
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								x="0px"
								y="0px"
								width="15px"
								height="15px"
								viewBox="0 0 512 512"
								style="margin-right: 5px; enable-background: new 0 0 512 512"
								xml:space="preserve"
							>
								<g>
									<!-- <polygon points="67.41,0 34.256,0 20.999,47.732 34.283,47.732 22.988,88.408 26.967,88.408 65.418,40.674 45.939,40.674" fill="#a9870b"/> -->
									<path
										fill="#a9870b"
										d="M397.241,176.552H276.303L388.414,0H247.172L114.759,264.828h104.166L114.759,512L397.241,176.552z"
									/>
								</g>
							</svg>
							<span
								>Add an odd of
								{{
									Math.round((minAdditionalOddToQualify / totalOdds) * 100) /
									100
								}}
								or greater to unlock a win boost of
								{{ winBoostFactor * 100 }}%</span
							>
						</p>
					</div>

					<!-- /// Offers & Rewards v-if="env.availableFeatures.recommendations"-->
					<div
						v-if="
							loggedIn &&
							env.availableFeatures.freebets &&
							allFreebets.length > 0
						"
						style="cursor: pointer"
					>
						<div class="betslip__details__row" v-if="!freebetAppliedStatus">
							<div class="betslip__details__row--underline"></div>
						</div>
						<div class="betslip__details__row" v-if="!freebetApplied">
							<div
								class="betslip__details__row__label"
								v-if="
									(bets.length > 0 &&
										allFreebets &&
										allFreebets.length > 0 &&
										!freebetFetchingStatus &&
										!freebetAppliedStatus) ||
									Object.keys('selectedOptIn').length > 0
								"
								@click="$router.push({ path: '/freebets' })"
							>
								<svg
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="betslip__details__row__label__offersvg"
								>
									<path
										d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z"
										stroke="var(--black)"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9 15L15 9"
										stroke="var(--black)"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M14.4945 14.5H14.5035"
										stroke="var(--black)"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M9.49451 9.5H9.50349"
										stroke="var(--black)"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>

								<span
									class="betslip__details__row__column__text"
									style="white-space: nowrap"
								>
									{{ $t("betslip.offers-&-rewards") }}
									<span v-if="allFreebets.length > 0">
										• {{ allFreebets.length }}</span
									>
								</span>
								<svg
									class="betslip__details__row__column__icon"
									width="9"
									height="10"
									viewBox="0 0 9 10"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3.73047 1.55859C3.61328 1.65625 3.57422 1.77344 3.57422 1.89062C3.57422 2.02734 3.63281 2.14453 3.73047 2.22266L6.07422 4.46875H0.46875C0.332031 4.46875 0.214844 4.52734 0.136719 4.60547C0.0390625 4.70312 0 4.82031 0 4.9375V5.5625C0 5.69922 0.0390625 5.81641 0.136719 5.89453C0.214844 5.99219 0.332031 6.03125 0.46875 6.03125H6.07422L3.73047 8.27734C3.63281 8.375 3.57422 8.49219 3.57422 8.60938C3.57422 8.74609 3.61328 8.86328 3.73047 8.94141L4.16016 9.37109C4.23828 9.46875 4.35547 9.50781 4.49219 9.50781C4.60938 9.50781 4.72656 9.46875 4.82422 9.37109L8.61328 5.58203C8.69141 5.50391 8.75 5.38672 8.75 5.25C8.75 5.13281 8.69141 5.01562 8.61328 4.91797L4.82422 1.12891C4.72656 1.05078 4.60938 0.992188 4.49219 0.992188C4.35547 0.992188 4.23828 1.05078 4.16016 1.12891L3.73047 1.55859Z"
									/>
								</svg>
							</div>
							<span class="betslip__details__row__column__bottom"></span>
						</div>
					</div>

					<div class="betslip__details__row">
						<div class="betslip__details__row--underline"></div>
					</div>

					<!-- /// Balance -->
					<div class="betslip__details__row" v-if="loggedIn && !freebetApplied">
						<span class="betslip__details__row__label">{{
							$t("account.balance")
						}}</span>
						<div class="betslip__details__row__column">
							<span
								class="betslip__details__row__value"
								:class="{ applied: freebetApplied }"
								@click="
									() => {
										if ($store.getters.balance >= 1.2)
											amount = $store.getters.balance;
									}
								"
								>{{ $store.getters.balance | currency }}</span
							>
							<!-- <div
								class="betslip__details__row__column__bottom"
								v-if="
									(bets.length > 0 &&
										allFreebets &&
										allFreebets.length > 0 &&
										!freebetFetchingStatus &&
										!freebetAppliedStatus) ||
										Object.keys('selectedOptIn').length > 0
								"
								@click="$router.push({ path: '/freebets' })"
							>
								<img
									height="16px"
									src="../../assets/img/shopping-bag.png"
									alt=""
								/>

								<span
									class="betslip__details__row__column__text"
									style="white-space: nowrap"
								>
									Promos & Rewards
									<span v-if="allFreebets.length > 0">
										• {{ allFreebets.length }}</span
									>
								</span>
								<svg
									class="betslip__details__row__column__icon"
									width="9"
									height="10"
									viewBox="0 0 9 10"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3.73047 1.55859C3.61328 1.65625 3.57422 1.77344 3.57422 1.89062C3.57422 2.02734 3.63281 2.14453 3.73047 2.22266L6.07422 4.46875H0.46875C0.332031 4.46875 0.214844 4.52734 0.136719 4.60547C0.0390625 4.70312 0 4.82031 0 4.9375V5.5625C0 5.69922 0.0390625 5.81641 0.136719 5.89453C0.214844 5.99219 0.332031 6.03125 0.46875 6.03125H6.07422L3.73047 8.27734C3.63281 8.375 3.57422 8.49219 3.57422 8.60938C3.57422 8.74609 3.61328 8.86328 3.73047 8.94141L4.16016 9.37109C4.23828 9.46875 4.35547 9.50781 4.49219 9.50781C4.60938 9.50781 4.72656 9.46875 4.82422 9.37109L8.61328 5.58203C8.69141 5.50391 8.75 5.38672 8.75 5.25C8.75 5.13281 8.69141 5.01562 8.61328 4.91797L4.82422 1.12891C4.72656 1.05078 4.60938 0.992188 4.49219 0.992188C4.35547 0.992188 4.23828 1.05078 4.16016 1.12891L3.73047 1.55859Z"
									/>
								</svg>
							</div> -->
						</div>
					</div>

					<!-- /// Total Odds -->
					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.total-odds")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('general.minimum'),
										value: env.minTotalOdd,
										show: env.minTotalOdd,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
							/>
						</span>
						<span class="betslip__details__row__value"
							>{{ totalOdds > 1000000 ? "&#8734;" : totalOdds }}
							<br />
						</span>
					</div>

					<!-- /// Final Payout -->
					<div class="betslip__details__row finalpay">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.final-payout")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('betslip.excise-tax'),
										value: $options.filters.currency(exciseTax || 0),
										show: env.exciseTax > 0,
									},
									{
										label: this.$t('betslip.stake-after-tax'),
										value: $options.filters.currency(
											betAmount - exciseTax || 0
										),
										show: env.exciseTax > 0,
									},
									{
										label: this.$t('betslip.withholding-tax'),
										value: $options.filters.currency(tax || 0),
										show: env.whtTax > 0,
									},
									{
										label: env.accaBonusProductName,
										value: $options.filters.currency(AccaBonusAmount || 0),
										show: AccaBonusAmount > 0,
									},
									{
										label: this.$t('betslip.possible-win'),
										value: $options.filters.currency(possiblePayout || 0),
										show: AccaBonusAmount > 0,
									},
									{
										label: this.$t('betslip.final-payout'),
										value: $options.filters.currency(
											possiblePayout + AccaBonusAmount || 0
										),
										show: possiblePayout,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
							/>
							<cashout-indicator
								:totalOdds="totalOdds"
								:liveMatches="liveMatches"
								:betAmount="betAmount"
								:possibleWinnings="possibleWinnings"
								:areThereAnyInvalidMatches="areThereAnyInvalidMatches"
								:bets="bets"
							/>
						</span>
						<span class="betslip__details__row__value">
							{{ (possiblePayout + AccaBonusAmount || 0) | currency }}</span
						>
					</div>

					<!-- /// Amount -->
					<div class="betslip__details__row--amount">
						<div class="betslip__details__row">
							<span
								class="betslip__details__row__label"
								style="flex-basis: 10%"
								v-if="
									productAvailable('offersNRewards') &&
									Object.keys(optedInData).length !== 0
								"
							>
								<opted-in-list
									:ref="'optedInList'"
									:optedInData="optedInData"
									:selectedPromo="selectedOptIn"
									@change-promo-option="(option) => getSelectedOptIn(option)"
								/>
							</span>

							<div
								@click="removeFreeBet()"
								v-if="Object.keys(appliedFreebet).length !== 0"
								class="betslip__details__row__freebet"
							>
								<span class="betslip__details__row__freebet__label"
									>{{ appliedFreebet.amount | currency }}
									{{ $t("offers.free-bet-applied") }}</span
								>
								<span class="betslip__details__row__freebet__remove">
									<svg
										width="17"
										height="17"
										viewBox="0 0 22 22"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											opacity="0.4"
											d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
											fill="var(--always-white)"
										/>
										<path
											d="M13.06 12L15.36 9.7C15.65 9.41 15.65 8.93 15.36 8.64C15.07 8.35 14.59 8.35 14.3 8.64L12 10.94L9.69998 8.64C9.40998 8.35 8.92999 8.35 8.63999 8.64C8.34999 8.93 8.34999 9.41 8.63999 9.7L10.94 12L8.63999 14.3C8.34999 14.59 8.34999 15.07 8.63999 15.36C8.78999 15.51 8.97999 15.58 9.16999 15.58C9.35999 15.58 9.54998 15.51 9.69998 15.36L12 13.06L14.3 15.36C14.45 15.51 14.64 15.58 14.83 15.58C15.02 15.58 15.21 15.51 15.36 15.36C15.65 15.07 15.65 14.59 15.36 14.3L13.06 12Z"
											fill="var(--active-state)"
										/>
									</svg>
								</span>
							</div>

							<div class="betslip__details__row__input__currency-wrap" v-else>
								<span class="betslip__details__row__input__currency-code"
									>{{ this.$t("betslip.amount") }} ({{ env.currency }})</span
								>
								<b-input
									class="betslip__details__row__value input"
									:style="
										Object.keys(appliedFreebet).length !== 0
											? 'flex-basis: 90%'
											: 'flex-basis: 100%'
									"
									type="number"
									name="amount"
									v-model="amount"
									:disabled="placingBet"
									autocomplete="off"
									:min="env.minimumBetAmount"
									:step="env.minimumBetAmount"
									:max="env.maximumBetAmount"
									:placeholder="$t('betslip.enter-stake')"
									@mounted="
										$nextTick(() => {
											adjustBetslipHeight();
										})
									"
								>
								</b-input>
							</div>
						</div>
						<div
							class="betslip__details__row minmax"
							v-if="
								amount < env.minimumBetAmount || amount > env.maximumBetAmount
							"
						>
							<span
								>{{ $t("betslip.enter-amount-between") }}
								{{ env.minimumBetAmount | currency }} -
								{{ env.maximumBetAmount | currency }}</span
							>
						</div>
					</div>
				</div>

				<!-- BUTTONS I  -->
				<div
					class="betslip__details__buttons"
					v-if="
						bets.length > 0 &&
						(areThereAnyChangedOdds || areThereAnyInvalidMatches)
					"
				>
					<button
						v-if="areThereAnyChangedOdds && !areThereAnyInvalidMatches"
						class="betslip__details__button__place button button__primary full bold"
						@click="
							() => {
								acceptOddChanges();
								placeBet();
							}
						"
					>
						{{
							amount
								? $t("betslip.accept-and-place-bet")
								: $t("betslip.accept-odd-changes")
						}}
					</button>
					<button
						v-if="areThereAnyInvalidMatches"
						class="betslip__details__button__place--remove button button__primary full bold"
						@click="removeInvalidMatches()"
					>
						{{ this.$t("betslip.remove-expired") }}
					</button>
					<share-button
						v-if="!areThereAnyInvalidMatches"
						:bets="bets"
						:profile-id="loggedIn ? $store.getters.auth['user']['id'] : null"
						:token="loggedIn ? $store.getters.auth['token'] : null"
						:bet-id="null"
						:product-type="'PREMATCH'"
						:type="'full'"
						:shareButtonText="this.$t('betslip.share')"
					/>
				</div>

				<!-- BUTTONS II /  -->
				<div
					class="betslip__details__buttons"
					v-if="
						bets.length > 0 &&
						!areThereAnyChangedOdds &&
						!areThereAnyInvalidMatches
					"
				>
					<b-button
						:amount="amount"
						:possibleWin="possibleWinnings"
						:totalOdds="totalOdds"
						:bonus="bonus"
						:points="points"
						:numberOfBets="numberOfBets"
						type="normal"
						class="betslip__details__button__place button button__primary bold bet-share-button"
						:disabled="placeBetButtonValid"
						@click="placeBet"
						:title="placeBetButtonMessage"
						:loading="placingBet"
						@mounted="
							$nextTick(() => {
								adjustBetslipHeight();
							})
						"
					/>
					<share-button
						:bets="bets"
						:profile-id="loggedIn ? $store.getters.auth['user']['id'] : null"
						:token="loggedIn ? $store.getters.auth['token'] : null"
						:bet-id="null"
						:product-type="'PREMATCH'"
						:type="'full'"
						@mounted="
							$nextTick(() => {
								adjustBetslipHeight();
							})
						"
						:shareButtonText="this.$t('betslip.share')"
					/>
				</div>
			</div>
			<load-betslip v-if="bets.length == 0" />
		</div>

		<insufficient-balance
			:amount="amount"
			v-if="insufficientBal"
			@close="insufficientBal = false"
		/>
	</div>
</template>
<script>
import _, { isNull } from "lodash";
import OptedInList from "../Offers/Promos/OptedInList.vue";
import RulesIndicator from "../Offers/Promos/RulesIndicator.vue";
import LoadBetslip from "../Share/LoadBetslip.vue";
import ShareButton from "../Share/ShareButton.vue";
import AccaBonus from "./AccaBonus.vue";
import Bet from "./Bet.vue";
import CashoutIndicator from "./CashoutIndicator.vue";
import InsufficientBalance from "./InsufficientBalance.vue";
import RecommendationSlider from "./Recommendations.vue";

export default {
	name: "Betslip",
	components: {
		Bet,
		ShareButton,
		LoadBetslip,
		AccaBonus,
		CashoutIndicator,
		InsufficientBalance,
		OptedInList,
		RecommendationSlider,
		RulesIndicator,
	},
	props: ["keep"],
	data() {
		return {
			placingBet: false,
			sharingBet: false,
			currentTime: +new Date(),
			timerIntervalID: null,
			minStake: window.MINIMUM_BET_AMOUNT,
			maxPossibleWin: window.MAXIMUM_POSSIBLE_WIN,
			maxBonus: window.MAXIMUM_POSSIBLE_WIN,
			betslipLiveUpdateInterval: null,
			betslipPrematchUpdateInterval: null,
			infoOpen: false,
			freebetApplied: false,
			minAdditionalOddToQualify: 3,
			freeBets: [],
			qualificationMessages: [],
			qualifiesForFreebet: false,
			freebetQualificationLoading: false,
			previousStake: 0,
			insufficientBal: false,
			selectedOptIn: {},
			promoAmount: 0,
			AccaBonusAmount: 0,
		};
	},
	mounted() {
		let vm = this;
		const useRefreshBetslipAPI = vm.env.availableFeatures.sbBetslipMatchesRefresh;

		if (vm.loggedIn && !vm.freebetAppliedStatus) {
			vm.$store.dispatch("freebets/getFreebets").catch((error) => {
				if (error) {
					if (error.status === 401) {
						vm.$auth.logout();

						vm.$notifications.add({
							message: "Your session has expired. Please login again",
							title: "Session expired",
							type: "error",
							duration: 5000,
						});
						vm.$router.push("/login?next=" + vm.$route.fullPath);
					}
				}
			});
		}

		if (!vm.env.setMinimumAmountInBetslip) {
			vm.$store.commit("updateStake", "");
		}
		vm.updateCurrentTime();
		if (!useRefreshBetslipAPI) {
			vm.updateLiveMatches();
		} else {
			vm.updateLiveMarketsWithRefreshApi();
		}
		vm.checkFreebetExpiry();
		vm.betslipLiveUpdateInterval = window.setInterval(() => {
			if (!useRefreshBetslipAPI) {
				vm.updateLiveMatches();
			} else {
				vm.updateLiveMarketsWithRefreshApi();
			}
		}, 7000);
		vm.betslipPrematchUpdateInterval = window.setInterval(() => {
			if (useRefreshBetslipAPI) {
				vm.updatePrematchMarketsWithRefreshApi();
			}
		}, 10000);
		if (!localStorage["betika-platform-settings"])
			vm.$auth.updateUserSettings();

		if (vm.$route.query.ref) vm.reloadBetslip(vm.$route.query.ref);
		if (vm.$store.getters.layout == "Desktop" && vm.bets.length > 0) {
			vm.$nextTick(() => {
				vm.adjustBetslipHeight();
			});
		}

		let optedInPromos = vm.$store.getters["promos/optedInPromo"];

		if (optedInPromos.length == 1) {
			vm.selectedOptIn = optedInPromos[0];
			const optInAmount = vm.selectedOptIn.rules.find(
				(rule) => rule.rule == "opt-in-min-bet-amount"
			).value;
			if (optInAmount && vm.amount < optInAmount) vm.amount = optInAmount;
		} else {
			vm.selectedOptIn = localStorage.getItem("selected-optIn")
				? JSON.parse(localStorage.getItem("selected-optIn"))
				: {};

			window.addEventListener("selected-optIn", (event) => {
				vm.selectedOptIn = event.detail.storage;
			});
		}

		if (vm.$store.getters.layout == "Desktop") {
			if (vm.bets.length === 0) return;
			document
				.querySelector(".betslip-content")
				.scroll({ behavior: "smooth", top: 10000 });
		} else {
			vm.$nextTick(() => {
				if (vm.bets.length === 0) return;
				let el = document.getElementById("slips");

				el.scrollIntoView(false);
				window.scrollBy(0, 10000);
			});
		}
	},
	beforeDestroy() {
		let vm = this;
		window.clearInterval(vm.timerIntervalID);
		window.clearInterval(vm.betslipLiveUpdateInterval);
		window.clearInterval(vm.betslipPrematchUpdateInterval);
		vm.timerIntervalID = null;
		vm.betslipLiveUpdateInterval = null;
		vm.betslipPrematchUpdateInterval = null;
	},
	watch: {
		amount(n, o) {
			if (!isNaN(parseFloat(n))) {
				this.amount = Math.round(n * 100) / 100;
			} else {
				this.amount = 0;
			}

			this.checkPromoAmount();
			this.getAccaBonusAmt();
		},
		numberOfBets(n, o) {
			let vm = this;
			if (n == 1 && o == 0) {
				vm.$nextTick(() => {
					vm.adjustBetslipHeight();
				});
			}
			vm.$nextTick(() => {
				if (n === 0) return;
				document
					.querySelector(".betslip-content")
					.scroll({ behavior: "smooth", top: 10000 });
			});
		},
	},
	computed: {
		placeBetButtonValid() {
			return (
				this.totalOdds < this.env.minTotalOdd ||
				this.placingBet ||
				(this.freebetAppliedStatus && !this.freebetValid.validity) ||
				this.amount < this.env.minimumBetAmount ||
				isNaN(this.amount)
			);
		},
		placeBetButtonMessage() {
			if (this.totalOdds < this.env.minTotalOdd)
				return this.$t("betslip.button-min-odd", {
					minTotalOdd: this.env.minTotalOdd,
				});
			return this.freebetAppliedStatus
				? this.freebetValid.validity
					? this.$t("betslip.button-free-bet", {
							amount: this.$options.filters.currency(
								this.appliedFreebet.amount
							),
						})
					: this.$t("betslip.button-free-bet-min-odd", {
							minOdd: this.freebetValid.minOdd,
						})
				: `${
						this.$t("betslip.button-place-bet") +
						" " +
						this.$options.filters.currency(this.amount === "" ? 0 : this.amount)
					}`;
		},
		freebetValid() {
			let vm = this;
			let validity = false;
			let minOddRule = [];
			if (
				vm.freebetAppliedStatus &&
				Object.keys(vm.appliedFreebet).length !== 0 &&
				vm.appliedFreebet.claim_rules &&
				Object.keys(vm.optedInData).length === 0
			) {
				minOddRule = vm.appliedFreebet.claim_rules.filter((freebet) => {
					return freebet.rule_name == "min_odd";
				});
				if (minOddRule.length > 0) {
					validity = vm.totalOdds >= minOddRule[0].rule_value ? true : false;
				} else {
					validity = true;
				}
			}
			let minOdd = minOddRule.length > 0 ? minOddRule[0].rule_value : "";
			return { validity, minOdd };
		},
		freebetAppliedStatus() {
			let vm = this;
			return vm.$store.getters["freebets/freebetAppliedStatus"];
		},
		freebetFetchingStatus() {
			let vm = this;
			return vm.$store.getters["freebets/freebetFetchingStatus"];
		},
		allFreebets() {
			let vm = this;
			if (Object.keys(vm.optedInData).length === 0) {
				return vm.$store.getters["freebets/allFreebets"];
			} else {
				return [];
			}
		},
		betAmount() {
			if (
				this.amount === "" ||
				this.amount === null ||
				isNaN(parseFloat(this.amount))
			) {
				return 0;
			}
			return parseFloat(this.amount);
		},
		appliedFreebet() {
			let vm = this;
			return vm.$store.getters["freebets/appliedFreebet"];
		},
		amount: {
			get: function () {
				let vm = this;

				if (Object.keys(vm.appliedFreebet).length !== 0) {
					return vm.$store.getters["freebets/appliedFreebet"].amount;
				}

				const storeStake = vm.$store.getters.stake;

				if (!vm.env.setMinimumAmountInBetslip) {
					return storeStake === null || storeStake === "" || storeStake === 0
						? ""
						: storeStake;
				}

				if (isNull(storeStake)) {
					vm.$store.commit(
						"updateStake",
						parseFloat(vm.env.defaultStakeAmount)
					);
					return vm.env.defaultStakeAmount;
				}

				return storeStake;
			},
			set: function (stake) {
				this.$store.commit("updateStake", parseFloat(stake));
			},
		},
		bets() {
			return this.$store.state.betSlip;
		},
		user() {
			return this.$store.getters.user;
		},
		validFreeBets() {
			let vm = this;
			let reducer = this.bets.reduce(function (acc, bet) {
				if (bet.bet_type == "prebet") acc.push("PREMATCH_UOF");
				if (bet.bet_type == "live") acc.push("LIVEMATCH_UOF");
				return acc;
			}, []);
			let unique = reducer.filter((v, i, a) => a.indexOf(v) === i);
			if (unique && unique.length != 1) return null;

			let validFreeBets = vm.allFreebets.filter((freebet) => {
				return freebet.product_name == unique[0];
			});

			return validFreeBets;
		},
		matches() {
			return this.$store.state.matches;
		},
		totalOdds() {
			let oddValues = this.bets
				.filter((bet) => Number(bet.odd.odd_value) > 0)
				.map((bet) => Number(bet.odd.odd_value));

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
		},
		possibleWinnings() {
			if (isNaN(this.betAmount)) return 0;
			let possibleWin =
				Math.trunc(this.totalOdds * (this.betAmount - this.exciseTax) * 100) /
				100;
			let maxPossible = this.freebetAppliedStatus
				? this.env.maximumFreebetPossibleWin
				: this.env.maximumPossibleWin;

			return possibleWin > maxPossible ? maxPossible : possibleWin;
		},
		winBoostFactor() {
			// return this.$store.getters.platformSettings ? this.$store.getters.platformSettings.possible_win_boost : 0;
			return 0;
		},
		winBoost() {
			return this.totalOdds > this.minAdditionalOddToQualify
				? Math.round(this.possibleWinnings * this.winBoostFactor * 100) / 100
				: 0;
		},
		exciseTax() {
			return this.freebetAppliedStatus
				? 0
				: Math.round(
						(this.betAmount - this.betAmount / (1 + this.env.exciseTax)) * 100
					) / 100;
		},
		tax() {
			if(this.env.tax.witholding.enable_min_taxable_winnings){
				let taxableAmount = Number(this.possibleWinnings) + this.winBoost - Number(this.env.tax.witholding.min_taxable_winnings);

				if(this.env.tax.witholding.taxable_amnt_deduct_stake && !this.freebetAppliedStatus){
					taxableAmount = taxableAmount - this.betAmount;

					if(this.possibleWinnings == this.env.maximumPossibleWin){
						const stake = this.betAmount > this.env.maximumBetAmount ? this.env.maximumBetAmount : this.betAmount;
						taxableAmount = Number(this.possibleWinnings) - Number(stake);
					}
				}

				if(taxableAmount < 0){
					return 0;
				}

				const tax =
					Math.round(
						taxableAmount * this.env.whtTax * 100
					) /100;

				return tax;
			}

			if (this.freebetAppliedStatus) {
				return this.possibleWinnings * this.env.whtTax;
			}
			let maxTax = this.possibleWinnings * this.env.whtTax;
			let tax =
				Math.round(
					(this.possibleWinnings +
						this.winBoost -
						(this.betAmount - this.exciseTax)) *
						this.env.whtTax *
						100
				) / 100;
			if (tax < 0) return 0;
			return tax > maxTax ? maxTax : tax;
		},
		possiblePayout() {
			const isUg = this.env.country.toLowerCase().includes("ug");

			return this.freebetAppliedStatus && !isUg
				? Math.trunc(
						(this.possibleWinnings +
							this.winBoost -
							this.betAmount -
							this.tax) *
							100
					) / 100
				: Math.trunc((this.possibleWinnings + this.winBoost - this.tax) * 100) /
						100;
		},
		bonus() {
			// Give bonus to only those bets with odd values >= 1.6
			let validOdds = this.bets
				.filter((bet) => Number(bet.odd.odd_value) >= 1.6)
				.map((bet) => bet.odd.odd_value);

			let numberOfValidOdds = validOdds.length;
			let minimumCountToAwardBonus = 5;

			if (numberOfValidOdds < minimumCountToAwardBonus) return 0;
			if (numberOfValidOdds > 14) numberOfValidOdds = 14;

			let percentageBonusForCount = {
				5: 0.05,
				6: 0.06,
				7: 0.07,
				8: 0.08,
				9: 0.1,
				10: 0.1,
				11: 0.12,
				12: 0.2,
				13: 0.2,
				14: 0.2,
			};

			let bonus =
				percentageBonusForCount[numberOfValidOdds] * this.possibleWinnings;
			return bonus > this.maxBonus ? this.maxBonus : bonus;
		},
		points() {
			//  from 100 to 500 stake max points per bet is 50
			//  from 501 to 5000 stake max points per bet are 100
			//  from 5001 and above stake max points per bet are 200
			//  max points per day to be 500
			let points;
			if (this.totalOdds >= 4.99) {
				switch (true) {
					case this.amount < 20:
						points = 0;
						break;

					case this.amount >= 20 && this.amount < 50:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 10 ? 10 : points;
						break;

					case this.amount >= 50 && this.amount < 100:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 25 ? 25 : points;
						break;

					case this.amount >= 100 && this.amount < 501:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 50 ? 50 : points;
						break;

					case this.amount > 500 && this.amount < 5001:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 100 ? 100 : points;
						break;

					case this.amount > 5000:
						points = (Number(this.amount) * Number(this.totalOdds)) / 100;
						points = points > 200 ? 200 : points;
						break;

					default:
						points = 0;
						break;
				}
			} else {
				points = 0;
			}
			return points;
		},
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		liveMatches() {
			return (
				this.bets.filter((bet) => {
					return bet.live;
				}).length > 0
			);
		},
		prebetMatches() {
			return (
				this.bets.filter((bet) => {
					return !bet.live;
				}).length > 0
			);
		},
		numberOfBets() {
			return this.bets.length;
		},
		areThereAnyChangedOdds() {
			return (
				this.bets.filter((bet) => {
					return bet.changed;
				}).length > 0
			);
		},
		areThereAnyInvalidMatches() {
			let vm = this;
			return (
				this.bets.filter((bet) => {
					return (
						bet.status == "STOPPED" ||
						!Number(bet.odd.odd_value) ||
						(bet.live
							? !bet.active
							: +new Date(
									this.$options.filters.timeZoneTimeStamp(bet.startTime)
								) < vm.currentTime)
					);
				}).length > 0
			);
		},
		auth() {
			let user = this.$store.getters.user;
			let token = this.$store.getters.token;
			return { user, token };
		},
		optedInData() {
			return this.$store.getters["promos/optedInPromo"]
				? this.$store.getters["promos/optedInPromo"]
				: [];
		},
		settings() {
			return this.$store.getters["settings/settings"];
		},
		v2PaymentsEnabled() {
			return this.supportsV2Payments();
		},
	},
	methods: {
		checkPromoAmount() {
			if (Object.keys(this.selectedOptIn).length > 0) {
				this.selectedOptIn.rules.find((r) => {
					if (
						r.rule === "opt-in-min-bet-amount" &&
						this.amount < JSON.parse(r.value) &&
						this.amount != 0
					) {
						this.promoAmount =
							"Increase your stake to " +
							r.value +
							" to opt in to " +
							this.selectedOptIn.promo_name;
					} else {
						this.promoAmount = 0;
					}
				});
			}
		},
		adjustBetslipHeight() {
			if (this.$store.getters.layout !== "Desktop") return;
			var desktopOffset = parseInt(
				getComputedStyle(document.body)
					.getPropertyValue("--desktop-header-offset")
					.trim()
					.replace("px", "")
			);
			var betslipDetailsHeight = document
				.querySelector(".betslip__details")
				.getBoundingClientRect().height;

			var navHeight =
				document.querySelector(".main-betslip__nav").getBoundingClientRect()
					.height +
				document.querySelector(".main-betslip__header").getBoundingClientRect()
					.height;
			var padding = 4;
			var bottomOffset = 0;
			var betslipContentHeight = `${
				window.innerHeight -
				(desktopOffset +
					betslipDetailsHeight +
					padding +
					bottomOffset +
					navHeight)
			}px`;
			document.querySelector(".betslip-content").style.height =
				betslipContentHeight;
			document.querySelector(".betslip-content").classList.add("adjusted");
		},
		debounceCheckFreebetQualification: _.debounce(function () {
			let vm = this;
			console.log("[Freebet Qualification] Got here ");
			if (!vm.loggedIn) return;

			let payload = {
				profile_id: parseInt(vm.auth.user.id),
				bet_amount: parseFloat(vm.amount),
				total_odd: parseFloat(vm.totalOdds),
				free_bet_id: 3,
				app_version: "6.0.1",
				client: "MOBILE_WEB",
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
			};

			vm.freebetQualificationLoading = true;

			vm.$axios
				.post(`${FREE_BETS_API_URL}qualification`, payload)
				.then((res) => {
					vm.qualifiesForFreebet = res.data.qualified;
					vm.qualificationMessages = res.data.messages;
					vm.freebetQualificationLoading = false;
				})
				.catch((error) => {
					console.log("[Freebet] Error getting qualification status");
				});
		}, 1000),
		checkFreebetQualification() {
			let vm = this;
			console.log("[Freebet Qualification] Got here ");
			if (!vm.loggedIn) return;

			let payload = {
				profile_id: parseInt(vm.auth.user.id),
				bet_amount: parseFloat(vm.amount),
				total_odd: parseFloat(vm.totalOdds),
				free_bet_id: 3,
				app_version: "6.0.0",
				client: "MOBILE_WEB",
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
			};

			vm.freebetQualificationLoading = true;

			vm.$axios
				.post(`${FREE_BETS_API_URL}qualification`, payload)
				.then((res) => {
					vm.qualifiesForFreebet = res.data.qualified;
					vm.qualificationMessages = res.data.messages;
					vm.freebetQualificationLoading = false;
				})
				.catch((error) => {
					console.log("[Freebet] Error getting qualification status");
				});
		},
		checkFreebetExpiry() {
			let vm = this;

			let freeBetExpiryTime = vm.freebetAppliedStatus
				? this.$options.filters.timeFormat(
						vm.appliedFreebet.expiry_date,
						" yyyy-MM-dd hh:mm:ss"
					)
				: "";

			if (
				vm.freebetAppliedStatus &&
				new Date(freeBetExpiryTime.replace(/-/g, "/")) < this.currentTime
			) {
				vm.$store.dispatch("freebets/removeAppliedFreebet", {});
				vm.$store.dispatch("freebets/getFreebets");
			}
		},
		applyFreeBet() {
			let vm = this;
			vm.$store.dispatch("freebets/applyFreebet", vm.validFreeBets[0]);
			vm.previousStake = vm.amount;
			// vm.amount = vm.validFreeBets[0].amount;
			vm.freebetApplied = true;
		},
		removeFreeBet() {
			let vm = this;
			vm.$store.dispatch("freebets/removeAppliedFreebet", {});
			vm.freebetApplied = false;
		},
		getFreeBets() {
			let vm = this;
			let token = localStorage.token ? JSON.parse(localStorage.token) : null;
			if (!vm.loggedIn || !token) return;

			let payload = {
				product: "",
				token: token,
			};

			vm.$axios
				.post(`${FREE_BETS_API_URL}free-bets-profile`, payload)
				.then((res) => {
					vm.freeBets = res.data;
					if (res.data.length == 0 && vm.freebetAppliedStatus)
						vm.$store.dispatch("freebets/removeAppliedFreebet", {});
				})
				.catch((error) => {
					console.log("[Freebet] Error getting freebets");

					if (error.response) {
						if (error.response.status === 401) {
							window.localStorage.setItem("authenticated", false);
							window.localStorage.removeItem("user");
							window.localStorage.removeItem("token");

							vm.$notifications.add({
								message: "Your session has expired. Please login again",
								title: "Session expired",
								type: "error",
								duration: 5000,
							});
							vm.$router.replace("/login?next=" + vm.$route.fullPath);
						}
					}
				});
		},
		reloadBetslip(ref) {
			let vm = this;
			let betslip = null;
			try {
				betslip = JSON.parse(sessionStorage[`bet_ref_${ref}`]);
			} catch (e) {
				return;
			}
			if (!betslip) return;
			vm.$store.commit("clearBetslip");
			betslip.forEach((bet) => vm.$store.commit("addToBetslip", bet));
		},
		updateCurrentTime() {
			let vm = this;
			vm.timerIntervalID = setInterval(() => {
				vm.currentTime = +new Date();
			}, 1000);
		},
		clearBetslip() {
			if (window.confirm(this.$t("betslip.clear-betslip"))) {
				this.analyticsTrack("betSlip", "clear", {
					bet_slip_count: this.bets.length || null,
				});
				this.$store.commit("clearBetslip");
			}
		},
		refreshBalance() {
			if (this.env.availableFeatures.balanceWidget) {
				this.$root.$emit("update-user-balance");
			} else {
				this.$axios
					.post(`${BASE_URL}balance`, {
						token: window.localStorage.getItem("token")
							? JSON.parse(window.localStorage.getItem("token"))
							: "",
					})
					.then((response) => {
						this.$store.commit("setBalance", response.data.data.balance);
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		placeBet() {
			if (this.areThereAnyChangedOdds) return;
			if (!this.amount) return;
			if (this.placingBet) return;
			let vm = this;
			vm.insufficientBal = false;
			let now = new Date();
			if (
				this.$store.state.betSlip.find((bet) => {
					return bet.live;
				})
			) {
				if (
					now.getUTCHours() > 22 &&
					now.getUTCHours() < 5 &&
					this.amount > vm.env.maximumBetAmount
				)
					return vm.$notifications.add({
						message: this.$t("betslip.max-live-bet", {
							amount: vm.$options.filters.currency(vm.env.maximumBetAmount),
						}),
						title: this.$t("betslip.bet-limit-warning"),
						type: "warning",
						duration: 5000,
					});
				if (
					now.getUTCHours() > 5 &&
					now.getUTCHours() < 22 &&
					this.amount > vm.env.maximumBetAmount
				)
					return vm.$notifications.add({
						message: vm.$t("betslip.max-live-bet", {
							amount: vm.$options.filters.currency(vm.env.maximumBetAmount),
						}),
						title: vm.$t("betslip.bet-limit-warning"),
						type: "warning",
						duration: 5000,
					});
			}
			vm.placingBet = true;
			if (vm.liveMatches) vm.keep = false;
			// Check whether the user is authenticated
			if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
				vm.placingBet = false;
				vm.$notifications.add({
					message: this.$t("session.please-login-to-place-bet"),
					title: this.$t("session.authentication-required"),
					type: "warning",
					duration: 3000,
				});
				vm.$router.push("/login");
				return;
			}

			// Check whether amount > 50
			if (vm.amount < vm.env.minimumBetAmount) {
				vm.placingBet = false;
				vm.$notifications.add({
					message: this.$t("min-bet", {
						amount: vm.$options.filters.currency(vm.env.minimumBetAmount),
					}),
					title: this.$t("betslip.bet-limit-warning"),
					type: "warning",
					duration: 3000,
				});
				return;
			}

			// Map betslip to endpoint requirements
			let betslip = this.bets.map((bet) => {
				return {
					sub_type_id: bet.type,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					outcome_id: bet.odd.outcome_id,
					sport_id: bet.odd.sport_id,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.odd.parent_match_id,
					bet_type: bet.live ? 8 : 7,
					is_shared: bet.is_shared,
					share_code: bet.share_code,
					provider: bet.provider
				};
			});

			// Build payload
			let payload = {
				profile_id: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				stake: this.amount.toString(),
				total_odd: this.totalOdds.toString(),
				src: "MOBILE_WEB",
				betslip: betslip,
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
				user_agent: navigator.userAgent,
				app_version: "6.0.0",
				affiliate: sessionStorage.affiliate ? sessionStorage.affiliate : null,
				promo_id:
					Object.keys(vm.selectedOptIn).length !== 0
						? JSON.parse(vm.selectedOptIn.promo_id)
						: null,
				fbpid:
					Object.keys(vm.appliedFreebet).length !== 0 && vm.freebetAppliedStatus
						? vm.appliedFreebet.free_bet_profile_id
						: false,
				is_freebet: vm.freebetAppliedStatus ? true : false,
			};

			if (
				vm.$store.getters["affiliates/affiliateTag"] &&
				vm.env.availableFeatures.affiliates
			) {
				payload.affiliate_id = vm.$store.getters["affiliates/affiliateID"];
				payload.affiliate_tag = vm.$store.getters["affiliates/affiliateTag"];
			}

			vm.placingBet = true;

			const parentMatchIds = betslip.map((bet) =>
				parseInt(bet.parent_match_id)
			);
			this.analyticsTrack("sportsbookBet", "attempt", {
				betslip: payload.betslip,
				num_Of_Bets: vm.numberOfBets,
				stake: vm.$options.filters.currency(vm.amount),
				user_id: payload.profile_id,
				bet_type: vm.liveMatches ? "live" : "prematch",
			});
			const url = `${BASE_V2_URL}bet`;
			// Server request
			let delay = 0;
			setTimeout(() => {
				vm.$axios
					.post(url, payload)
					.then((response) => {
						vm.$notifications.add({
							message: response.data.message,
							type: "success",
							duration: 10000,
							title: response.data.async
								? this.$t("betslip.bet-submitted")
								: this.$t("betslip.bet-placement-successful"),
						});
						vm.placingBet = false;
						vm.refreshBalance();
						this.analyticsTrack("sportsbookBet", "success", {
							betslip: payload.betslip,
							stake: vm.$options.filters.currency(vm.amount),
							total_odds: vm.totalOdds,
							ticket_id: response.data.ticketId,
							ref: response.data.ref || null,
							user_id: payload.profile_id,
							message: response.data.message,
							bet_type: vm.liveMatches ? "live" : "prematch",
							value: Number(vm.amount) || 0,
							currency: window.CURRENCY,
						});

						vm.$notifications.registerDeviceForNotifications();
						if (vm.keep) return;
						if (response.data.async)
							sessionStorage[`bet_ref_${response.data.ref}`] = JSON.stringify(
								vm.bets
							);

						vm.updateOptInData();
						vm.$store.commit("clearBetslip");
						vm.$store.dispatch("freebets/removeAppliedFreebet", {});
						vm.removeFreeBet();
						vm.$store.commit("SET_MYBETS_LAST_FETCH_TIME", null);
						vm.$store.dispatch("recommendations/trackPlaceBet", {
							ref: response.data.ref,
						});
						if (vm.$store.getters.layout == "Mobile") vm.$router.go(-1);
					})
					.catch((error) => {
						vm.placingBet = false;
						vm.$store.dispatch("freebets/removeAppliedFreebet", {});
						this.analyticsTrack("sportsbookBet", "failed", {
							betslip: payload.betslip,
							num_Of_Bets: vm.numberOfBets,
							stake: vm.$options.filters.currency(vm.amount),
							bet_type: vm.liveMatches ? "live" : "prematch",
							user_id: payload.profile_id,
							message: error.response
								? error.response.data.message
								: error.message,
						});
						if (error.response) {
							if (error.response.status == 401) {
								window.localStorage.setItem("authenticated", false);
								window.localStorage.removeItem("user");
								window.localStorage.removeItem("token");
								vm.$notifications.add({
									message: this.$t("session.expired"),
									title: this.$t("session.authentication-required"),
									type: "error",
									duration: 5000,
								});
								vm.$router.replace("/login?next=/betslip");
								return;
							} else {
								if (error.response.data.insufficient_bal) {
									// redirect to v2 payments for countries that support v2 payments
									if (vm.v2PaymentsEnabled) {
										vm.$notifications.add({
											message: error.response.data.message,
											title: this.$t("account.insufficient-funds"),
											type: "error",
											duration: null,
										});
										vm.$router.replace("/profile/deposit");
									} else {
										vm.insufficientBal = true;
									}
								} else if(error.response.data.has_invalid_selections){
									vm.$notifications.add({
										message: error.response.data.message,
										title: this.$t("betslip.bet-placement-failed"),
										type: "error",
										duration: null,
									});
									const invalidSelections = error.response.data.invalid_selections || [];
									if(invalidSelections.length > 0) {
										vm.updateInvalidBetsInBetslip(invalidSelections);
									}

								}else {
									vm.$notifications.add({
										message: error.response.data.message,
										title: this.$t("betslip.bet-placement-failed"),
										type: "error",
										duration: null,
									});
								}
							}
						} else {
							vm.$notifications.add({
								message: error.message,
								title: this.$t("betslip.bet-placement-failed"),
								type: "error",
								duration: null,
							});
						}
					});
			}, delay);
		},
		acceptOddChanges() {
			if (this.placingBet) return;
			this.$store.state.betSlip.map((bet) => {
				return (bet.changed = false);
			});
		},
		removeInvalidMatches() {
			if (this.placingBet) return;
			this.$store.commit("removeInvalidMatches");
		},
		updateLiveMatches(loaded = false) {
			let vm = this;
			let live_bets = vm.$store.state.betSlip.filter((bet) => {
				return bet.live;
			});

			live_bets.forEach((bet) => {
				vm.getMarkets(bet.matchId, bet.type)
				.then((market) => {
					if (!market.data || market.data.length == 0) {
						const expiredOddPayload = {
							matchId: bet.matchId,
							type: bet.type,
							newOdd: null,
							specialBetValue: bet.odd.special_bet_value,
							oddKey: bet.odd.odd_key,
						};

						const expiredOddMatchData = {
							bet_status: "STOPPED",
							active: false,
						};

						vm.informBetslipThatMarketOddsHaveChanged(expiredOddPayload, expiredOddMatchData);
						return;
					}

					if (!market.meta) return;

					let newOdds = market.data[0].odds;
					for (let odd in newOdds) {
						if (
							newOdds[odd].odd_key.toLowerCase() ==
							bet.odd.odd_key.toLowerCase()
						) {
							const payload = {
								matchId: market.meta.match_id,
								type: market.data[0].sub_type_id,
								newOdd: newOdds[odd].odd_value,
								specialBetValue: newOdds[odd].special_bet_value,
								oddKey: newOdds[odd].odd_key,
							};
							const matchData = {
								bet_status: market.meta.bet_status,
								active: newOdds[odd].odd_active == "1" &&
									newOdds[odd].market_active == "1"
							}

							if (newOdds[odd].special_bet_value) {
								if (
									newOdds[odd].special_bet_value ==
									bet.odd.special_bet_value
								) {
									vm.informBetslipThatMarketOddsHaveChanged(payload,matchData);
								}
							} else {
								vm.informBetslipThatMarketOddsHaveChanged(payload,matchData);
							}
						}
					}
				})
				.catch((error) => {});

			});
			if (loaded) loaded("done");
		},
		getMarkets(matchId, subTypeId) {
			let vm = this;
			 new Promise((resolve, reject) => {
				vm.$axios
					.get(`${LIVE_URL}uo/match?id=${matchId}&type=${subTypeId}`)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		updateLiveMarketsWithRefreshApi() {
			const vm = this;
			const live_bets = vm.$store.state.betSlip.filter((bet) => {
				return bet.live;
			});

			if (!Array.isArray(live_bets) || !live_bets.length) return;

			const refreshPayload = live_bets.map((bet) => ({
				odd_value: bet.odd.odd_value,
				outcome_id: bet.odd.outcome_id,
				parent_match_id: bet.parent_match_id,
				special_bet_value: bet.special_bet_value,
				sub_type_id: bet.sub_type_id
			}));

			vm.getRefreshedMarkets({
				data: refreshPayload
			}, 'live')
			.then((res) => {
				const refreshedOdds = res.data;
				refreshedOdds.forEach((newOdd) => {
					const correspondingBet = live_bets.find((bet) => (bet.odd.outcome_id == newOdd.outcome_id && bet.sub_type_id == newOdd.sub_type_id && bet.parent_match_id == newOdd.parent_match_id));
					if (correspondingBet) {
						const payload = {
							matchId: correspondingBet.matchId,
							type: correspondingBet.type,
							newOdd: Number(newOdd.odd_value) ? Number(newOdd.odd_value).toFixed(2) : 0,
							specialBetValue: newOdd.special_bet_value,
							oddKey: correspondingBet.odd.odd_key,
						};
						const matchData = {
							bet_status: newOdd.active ? "STARTED" : "STOPPED",
							active: newOdd.active,
						};
						vm.informBetslipThatMarketOddsHaveChanged(payload, matchData);
					}
				});
			}).catch((error) => {});
		},
		updatePrematchMarketsWithRefreshApi() {
			const vm = this;
			const prematch_bets = vm.$store.state.betSlip.filter((bet) => {
				return !bet.live;
			});

			if (!Array.isArray(prematch_bets) || !prematch_bets.length) return;

			const refreshPayload = prematch_bets.map((bet) => ({
				odd_value: bet.odd.odd_value,
				outcome_id: bet.odd.outcome_id,
				parent_match_id: bet.parent_match_id,
				special_bet_value: bet.special_bet_value,
				sub_type_id: bet.sub_type_id
			}));

			vm.getRefreshedMarkets({
				data: refreshPayload
			}, 'prematch')
			.then((res) => {
				const refreshedOdds = res.data;
				refreshedOdds.forEach((newOdd) => {
					const correspondingBet = prematch_bets.find((bet) => (bet.odd.outcome_id == newOdd.outcome_id && bet.sub_type_id == newOdd.sub_type_id && bet.parent_match_id == newOdd.parent_match_id));
					if (correspondingBet) {
						const payload = {
							matchId: correspondingBet.matchId,
							type: correspondingBet.type,
							newOdd: Number(newOdd.odd_value) ? Number(newOdd.odd_value).toFixed(2) : 0,
							specialBetValue: newOdd.special_bet_value,
							oddKey: correspondingBet.odd.odd_key,
						};
						const matchData = {
							bet_status: newOdd.active ? "STARTED" : "STOPPED",
							active: newOdd.active,
						};
						vm.informBetslipThatMarketOddsHaveChanged(payload, matchData);
					}
				});
			}).catch((error) => {});
		},
		getRefreshedMarkets(payload, matchType) {
			let vm = this;
			return new Promise((resolve, reject) => {
				vm.$axios
					.post(`${LIVE_URL}uo/refresh/${matchType}`, payload)
					.then((response) => {
						resolve(response.data)
					})
					.catch((error) => {
						reject(error);
					})
			});
		},
		updateInvalidBetsInBetslip(invalidBets){
			let vm = this;
			vm.$store.state.betSlip.filter((bet) => {
				return invalidBets.includes(parseInt(bet.parent_match_id));
			})
			.map((filteredBet) => {
				return {
					display: filteredBet.display,
					live: filteredBet.live,
					market: filteredBet.market,
					matchId: filteredBet.matchId,
					odd: {
						display: filteredBet.odd.display,
						odd_key: filteredBet.odd.odd_key,
						odd_value: filteredBet.odd.odd_value,
						parent_match_id: filteredBet.odd.parent_match_id,
						special_bet_value: filteredBet.odd.special_bet_value,
						parsed_special_bet_value: filteredBet.odd.parsed_special_bet_value,
						outcome_id: filteredBet.odd.outcome_id,
						sport_id: filteredBet.odd.sport_id,
					},
					initialOdd: filteredBet.initialOdd,
					startTime: filteredBet.startTime,
					type: filteredBet.type,
					changed: true,
					status: "STOPPED",
					active: false,

					// Coola data
					parent_match_id: filteredBet.parent_match_id,
					game_description: filteredBet.game_description,
					bet_pick: filteredBet.bet_pick,
					sub_type_id: filteredBet.sub_type_id,
					market_name: filteredBet.market_name,
					odd_key: filteredBet.odd_key,
					odd_value: filteredBet.odd_value,
					special_bet_value: filteredBet.special_bet_value,
					bet_type: filteredBet.bet_type,
					home_team: filteredBet.home_team,
					away_team: filteredBet.away_team,
					provider: filteredBet.provider
				};
			}).forEach((mappedBet) => {
				vm.$store.commit("replaceBetInBetslip", mappedBet)
			})
		},
		informBetslipThatOddsHaveChanged(payload, match) {
			let vm = this;
			vm.$store.state.betSlip
				.filter((bet) => {
					return bet.matchId == payload.matchId && bet.type == payload.type;
				})
				.map((filteredBet) => {
					return {
						display: filteredBet.display,
						live: filteredBet.live,
						market: filteredBet.market,
						matchId: filteredBet.matchId,
						odd: {
							display: filteredBet.odd.display,
							odd_key: filteredBet.odd.odd_key,
							odd_value:
								filteredBet.odd.odd_key == payload.type &&
								!filteredBet.odd.special_bet_value
									? payload.newOdd
									: filteredBet.odd.odd_value,
							parent_match_id: filteredBet.odd.parent_match_id,
							special_bet_value: filteredBet.odd.special_bet_value,
							parsed_special_bet_value:
								filteredBet.odd.parsed_special_bet_value,
							outcome_id: filteredBet.odd.outcome_id,
							sport_id: filteredBet.odd.sport_id,
						},
						initialOdd: filteredBet.initialOdd,
						startTime: filteredBet.startTime,
						type: filteredBet.type,
						changed: filteredBet.odd.odd_key == payload.type &&
							Number(payload.newOdd) != Number(filteredBet.odd.odd_value)
								? true
								: filteredBet.changed,
						status: match.bet_status,
						active: match.odd_active == "1",

						// Coola data
						parent_match_id: filteredBet.parent_match_id,
						game_description: filteredBet.game_description,
						bet_pick: filteredBet.bet_pick,
						sub_type_id: filteredBet.sub_type_id,
						market_name: filteredBet.market_name,
						odd_key: filteredBet.odd_key,
						odd_value: filteredBet.odd_value,
						special_bet_value: filteredBet.special_bet_value,
						bet_type: filteredBet.bet_type,
						home_team: filteredBet.home_team,
						away_team: filteredBet.away_team,
						provider: filteredBet.provider
					};
				})
				.forEach((mappedBet) => {
					vm.$store.commit("replaceBetInBetslip", mappedBet);
				});
		},
		informBetslipThatMarketOddsHaveChanged(payload, match) {
			let vm = this;
			vm.$store.state.betSlip
				.filter((bet) => {
					return (
						bet.matchId == payload.matchId &&
						bet.type == payload.type &&
						bet.odd.special_bet_value == payload.specialBetValue &&
						bet.odd.odd_key.toLowerCase() == payload.oddKey.toLowerCase()
					);
				})
				.map((filteredBet) => {
					return {
						display: filteredBet.display,
						live: filteredBet.live,
						market: filteredBet.market,
						matchId: filteredBet.matchId,
						odd: {
							display: filteredBet.odd.display,
							odd_key: filteredBet.odd.odd_key,
							odd_value: payload.newOdd,
							parent_match_id: filteredBet.odd.parent_match_id,
							special_bet_value: filteredBet.odd.special_bet_value,
							parsed_special_bet_value:
								filteredBet.odd.parsed_special_bet_value,
							outcome_id: filteredBet.odd.outcome_id,
							sport_id: filteredBet.odd.sport_id,
						},
						initialOdd: filteredBet.initialOdd,
						startTime: filteredBet.startTime,
						type: filteredBet.type,
						changed:
							Number(filteredBet.type) == Number(payload.type) &&
							Number(payload.newOdd) != Number(filteredBet.odd.odd_value)
								? true
								: filteredBet.changed,
						status: match.bet_status,
						active: match.active,

						// Coola data
						profile_id: filteredBet.profile_id,
						app_name: filteredBet.app_name,
						parent_match_id: filteredBet.parent_match_id,
						game_description: filteredBet.game_description,
						bet_pick: filteredBet.bet_pick,
						sub_type_id: filteredBet.sub_type_id,
						market_name: filteredBet.market_name,
						odd_key: filteredBet.odd_key,
						odd_value: payload.newOdd,
						special_bet_value: filteredBet.special_bet_value,
						bet_type: filteredBet.bet_type,
						home_team: filteredBet.home_team,
						away_team: filteredBet.away_team,
						provider: filteredBet.provider
					};
				})
				.forEach((mappedBet) => {
					vm.$store.commit("replaceBetInBetslip", mappedBet);
				});
		},
		getSelectedOptIn(option) {
			let vm = this;
			vm.selectedOptIn = option;
			if (!option || !option.rules) return;
			const optInAmount = option.rules.find(
				(rule) => rule.rule == "opt-in-min-bet-amount"
			).value;
			if (optInAmount && vm.amount < optInAmount) vm.amount = optInAmount;
		},
		updateOptInData() {
			let vm = this;
			if (Object.keys(vm.selectedOptIn).length > 0) {
				vm.$store.dispatch("promos/optOutPromo", vm.selectedOptIn.promo_id);
				vm.optedInData = JSON.parse(localStorage.getItem("btk-promo"));

				vm.selectedOptIn = {};
				localStorage.setItem("selected-optIn", JSON.stringify({}));
			}
		},
		getAccaBonusAmt(bonus) {
			let vm = this;
			if (vm.env.availableFeatures.accaBonus) {
				vm.AccaBonusAmount = bonus;
			}
		},
	},
	metaInfo() {
		let vm = this;
		if (vm.$route.name === "betslip") {
			let openGraphImage =
				vm.$store.getters["meta/metaShareImage"] ||
				vm.env.betShareDefaultImage;
			if (!openGraphImage) return;
			return {
				title: vm.env.betShareTitle,
				meta: [
					{
						vmid: "og:title",
						property: "og:title",
						content: vm.env.betShareTitle,
					},
					{
						vmid: "og:description",
						property: "og:description",
						content: vm.env.betShareDesciption,
					},
					{
						vmid: "og:site_name",
						property: "og:site_name",
						content: "betika",
					},
					{
						vmid: "og:type",
						property: "og:type",
						content: "website",
					},
					{
						vmid: "og:url",
						property: "og:url",
						content: vm.env.websiteUrl,
					},
					{
						vmid: "og:image",
						property: "og:image",
						content: openGraphImage,
					},

					// twitter card
					{
						vmid: "twitter:title",
						name: "twitter:title",
						content: vm.env.betShareTitle,
					},
					{
						vmid: "twitter:description",
						name: "twitter:description",
						content: vm.env.betShareDesciption,
					},
					{
						vmid: "twitter:image",
						name: "twitter:image",
						content: openGraphImage,
					},
					{
						vmid: "name",
						itemprop: "name",
						content: vm.env.betShareTitle,
					},
					{
						vmid: "description",
						itemprop: "description",
						content: vm.env.betShareDesciption,
					},
					{
						vmid: "image",
						itemprop: "image",
						content: openGraphImage,
					},
				],
			};
		}

		if (vm.$route.name == null) {
			return {
				title: vm.env.websiteTitle,
			};
		}
	},
};
</script>
<style lang="scss">
.betslip {
	margin-bottom: var(--margin-bottom);
	&__freebet {
		&__action {
			background: rgba(0, 0, 0, 0.1);
			padding: 5px 8px;
		}
		&__container {
			padding: 10px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			background: var(--green);
			color: var(--always-white);
			&--applied {
				background: var(--yellow);
				color: var(--always-black);
			}
			p {
				margin: 0;
			}
		}
	}
	&__load-code {
		&__container {
			bottom: var(--padding-bottom);
			transform: translateX(-50%);
			display: flex;
			align-items: center;
			width: 100%;
			max-width: var(--app-width);
			flex-direction: column;
		}
	}
	&__qualify {
		&__container {
			padding: 8px 0;
			display: flex;
			flex-direction: column;
			background: var(--green);
			color: var(--always-white);
		}
		&__list {
			padding-inline-start: 10px;
			list-style: none;
			margin: 0;
			&__item {
				padding-bottom: 5px;
			}
			&__text {
				padding-left: 5px;
			}
		}
		&__title {
			margin: 0;
		}
	}
	&__promotions {
		margin: 6px 10px 0 10px;
		h3 {
			font-weight: var(--font-weight-medium);
			margin-bottom: 8px;
			margin-top: 5px;
		}
		&--status {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			padding: 5px 0px 10px;
			text-decoration: none;
			font-weight: var(--font-weight-lighter);
			color: var(--green);
		}
	}
	&__details {
		&__button {
			&__desc {
				margin: 0;
				font-weight: var(--font-weight-lighter);
				font-size: var(--font-small);
			}
			&__place {
				border-radius: 4px;
				&--remove {
					border-radius: 4px;
				}
			}
		}
		&__row {
			&--amount {
				.minmax {
					font-weight: var(--font-weight-lighter);
					color: var(--non-active-state);
					font-size: var(--font-smallest);
					text-align: right !important;
					display: block;
				}
				.betslip__details__row {
					padding: 0px 10px 10px 10px;
				}
			}
			&__freebet {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				width: 100%;
				padding: 10px;
				background-color: var(--lightest-green);
				// border: 1px solid var(--lightest-green);
				border-radius: 4px;
				color: var(--green);

				&__label {
					line-height: 1.4rem;
				}
			}
			&--underline {
				width: 100%;
				margin: 0;
				border-bottom: 1px solid var(--line-11);
			}
			&__input {
				&__currency-wrap {
					position: relative;
					width: 100%;
				}
				&__currency-code {
					position: absolute;
					left: 15px;
					top: 50%;
					transform: translate(0%, -50%);
					font-size: var(--font-large);
				}
			}
		}
	}
}

.bet-share-button {
	flex: 1;
	min-width: fit-content;
}
</style>
